import { withInstall, SFCWithInstall } from '@touchvue/utils';
import Checkboxes from './src/Checkboxes.vue';

export const ToCheckboxes: SFCWithInstall<typeof Checkboxes> = withInstall(Checkboxes);
export * from './src/Checkboxes.vue';
